import type { CommonData } from '@models/commonData';

import { apiClient } from '@api/client';

export async function getCommonData(): Promise<CommonData> {
  const { data } = await apiClient.get<CommonData>('/common-data');

  return data;
}
